module.exports = __webpack_public_path__ + "static/media/em-120.aa28af74.png";